import React,{useEffect} from 'react'
import { useNavigate,Outlet, useLocation } from 'react-router-dom'
import Menu from './Menu'
import Footer from './Footer'


const Main = () => {
  const path = useLocation().pathname;

  useEffect(() => {
    window.scrollTo(0, 0);
  },[path])
  
  return (
    <div className='w-full h-auto'>
        <header className="h-fit">
            <Menu/>
        </header>
        <Outlet/>
        <Footer/>
    </div>
  )
}

export default Main